import React, { useState } from 'react';
import { resolve } from 'library/helpers/path-resolver';
import { ActionButton } from 'apps/journey/pages/professional-center/components/action-button';
import UserJourneyModal from 'apps/journey/pages/professional-center/individuals/user-journey-modal/user-journey-modal';
import UserOutcomesWrapper from 'apps/journey/context/user-outcomes-wrapper';
import OutcomesModal from 'apps/journey/components/modals/outcomes/outcomes-modal';
import { AllOutcomesLink } from 'apps/journey/components/modals/outcomes/outcomes-modal-body';
import {
  recommendOutcomesToUsersMutation,
  recommendOutcomesToUsersMutationParseQuery,
} from 'apps/journey/pages/professional-center/queries/recommendOutcomesToUsersMutation';
import { EyeNew } from 'library/icons';
import { NotificationRender } from 'library/components/notification';
import UserContext from 'context/user';
import { handleKeyPress } from 'library/helpers/key-press';
import { withConfig } from 'util/hoc';
import { capitalize } from 'library/helpers/text';

const ViewProfile = ({ data: user, width, configuration }) => {
  const [isActive, setIsActive] = useState(false);

  const outcomesIsActive = isActive === 'outcomes';
  const journeyIsActive = isActive === 'journey';

  const recommendOutcomeToUser = async ({
    outcome_id,
    included_goal_ids,
    recommendation_type,
    due_date,
  }) => {
    try {
      const { success, errors } = await recommendOutcomesToUsersMutation({
        user_uuids: [user.uuid],
        outcome_id,
        included_goal_ids,
        recommendation_type,
        due_date,
      });
      if (success) {
        NotificationRender(
          'success',
          `The ${resolve(
            configuration,
            'environment/journey/goals_name',
            'outcome'
          )} sharing was successful`
        );
        setIsActive(false);
        return;
      } else {
        console.errors(errors);
      }
    } catch (e) {
      console.error(e);
    }
    NotificationRender(
      'info',
      `The ${resolve(
        configuration,
        'environment/journey/goals_name',
        'outcome'
      )} sharing was unsuccessful`
    );
  };

  return (
    <UserContext.Provider value={{ user }}>
      {isActive ? (
        <UserOutcomesWrapper user={user} searchRow={true}>
          {journeyIsActive ? (
            <UserJourneyModal
              user={user}
              active={isActive}
              toggleActive={(active = !journeyIsActive) =>
                setIsActive(active ? 'journey' : false)
              }
              toggleRecommendations={(active = !outcomesIsActive) =>
                setIsActive(active ? 'outcomes' : false)
              }
            />
          ) : null}
          {outcomesIsActive ? (
            <OutcomesModal
              handleAddOutcome={recommendOutcomeToUser}
              headingText={`Share ${capitalize(
                resolve(
                  configuration,
                  'environment/journey/goals_name',
                  'Outcome'
                )
              )}`}
              headerDescription={`Select an ${capitalize(
                resolve(
                  configuration,
                  'environment/journey/goals_name',
                  'Outcome'
                )
              )} to share with the selected individual(s).`}
              actionButtonText="Next"
              navLinks={[AllOutcomesLink]}
              recommend_to_user={user}
              active={outcomesIsActive}
              toggleActive={(active = !outcomesIsActive) =>
                setIsActive(active ? 'outcomes' : false)
              }
              submitOutcomeActionParseQuery={
                recommendOutcomesToUsersMutationParseQuery
              }
              reloadOutcomes={() => null}
              uuids={[user.uuid]}
              showSummaryStep
            />
          ) : null}
        </UserOutcomesWrapper>
      ) : null}
      <ActionButton
        tabIndex={0}
        aria-label="View Profile."
        style={{ display: isActive === false ? 'flex' : 'none' }}
        onClick={() => setIsActive('journey')}
        onKeyPress={(e) => handleKeyPress(e, () => setIsActive('journey'))}
        iconComponent={EyeNew}
        width={width}
      >
        View Profile
      </ActionButton>
    </UserContext.Provider>
  );
};

export default withConfig(ViewProfile);
